// Modal
import React, { PropsWithChildren, useEffect } from 'react';
import styles from './Modal.module.sass';
import cn from 'classnames';

export interface ModalProps extends PropsWithChildren {
  open: boolean;
  onBackdropClick: () => void;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onBackdropClick,
  className,
  children,
}) => {
  useEffect(() => {
    if (document) {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }
  }, [open]);
  return open ? (
    <div
      style={open ? {} : { display: 'none' }}
      className={cn(styles.modal, className)}
      onClick={onBackdropClick}
    >
      {children}
    </div>
  ) : null;
};

export default Modal;

export const modalClickBlocker = (e: React.MouseEvent) => e.stopPropagation();
